export default {
    fontFamily: "Roboto, sans-serif"
};